import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/login";
// import "./styles/global.css";
import DashboardLayout from "./components/Layouts/DashboardLayout";
import Users from "./pages/users";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./components/Loader";
import Groups from "./pages/groups";
import CreateGroups from "./pages/groups/CreateGroups";
import Roles from "./pages/roles";
import CreateUsers from "./pages/users/CreateUsers";
import CreateRoles from "./pages/roles/CreateRoles";
import GroupDescription from "./pages/groups/GroupDescription";
import { apiUrls } from "./utils/api/apiUrls";
import useApi from "./hooks/useApi";
import UploadConfig from "./pages/uploadConfig/uploadConfig";
import UserData from "./pages/userData/userData";
import ForgotPassword from "./pages/login/forgetPassword";

const App = () => {


  // const { user, setUser } = useAuth();
  // const { apiCall } = useApi(false);

  // useEffect(() => {
  //   apiCall({
  //     url: apiUrls.user.profile,
  //     method: "get",
  //     onSuccess: (data) => {
  //       setUser({ ...user, ...data });
  //     },
  //   });
  // }, []);

  const router = () => (
    <div>
      <Router basename="/admin">
        <Routes>
          <Route index element={<Navigate to="/groups" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgetPassword" element={< ForgotPassword/>} />
          <Route element={<DashboardLayout />}>
            <Route path="/users/*" element={<Users />} />
            <Route path="/users/create" element={<CreateUsers />} />
            <Route path="/groups" element={<Groups />} />
            <Route path="/uploadConfig" element={<UploadConfig />} />
            <Route path="/userData" element={<UserData />} />
            <Route path="/groups/description" element={<GroupDescription />} />
            <Route path="/groups/create" element={<CreateGroups />} />
            <Route path="/roles" element={<Roles />} />
            <Route path="/roles/create" element={<CreateRoles />} />
          </Route>
          <Route
            path="*"
            element={
              <div className="flex items-center justify-center h-[100vh]">
                <strong className="text-[4rem]">404 Not Found</strong>
              </div>
            }
          />
        </Routes>
      </Router>
    </div>
  );

  const ShowLoader = () => {
    const { loading } = useAuth();
    return <Loader loading={loading} />;
  };

  return (
    <AuthProvider>
      <div className="bg-[var(--offWhite)] h-[100vh] font-family-regular">
        <ShowLoader />
        {router()}
        <ToastContainer
          hideProgressBar
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          style={{ fontSize: 15 }}
          autoClose={2000}
         />
      </div>
    </AuthProvider>
  );
};

export default App;
